// ** Icons Import
import { Settings, Home, Circle, MessageCircle } from 'react-feather'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNewspaper, faTrophy, faUsersCog } from '@fortawesome/free-solid-svg-icons'
export default [
  {
    id    : 'mnuNoticias',
    title : 'Noticias',
    icon  : <FontAwesomeIcon icon={faNewspaper} />,
    navLink : '/noticias'
  },
  {
    id    : 'mnuSistema',
    title : 'Sistema',
    icon  : <Settings size={20} />,
    children: [
      {
        id      : 'mnuSistemaRutas',
        title   : 'Rutas',
        icon    : <Circle size={12} />,
        navLink : '/administracion/rutas'
      },
      // {
      //   id      : 'mnuSistemaRoles',
      //   title   : 'Roles',
      //   icon    : <Circle size={12} />,
      //   navLink : '/administracion/roles'
      // },
      {
        id      : 'mnuSistemaPermisos',
        title   : 'Permisos',
        icon    : <Circle size={12} />,
        navLink : '/administracion/permisos'
      },
      {
        id      : 'mnuSistemaTiposUsuario',
        title   : 'Tipos de usuario',
        icon    : <Circle size={12} />,
        navLink : '/administracion/tipos-usuario'
      }
    ]
  },
  {
    id    : 'mnuAdministracion',
    title : 'Administración',
    icon  : <FontAwesomeIcon icon={faUsersCog} />,
    children: [
      {
        id      : 'mnuUsuarios',
        title   : 'Usuarios',
        icon    : <Circle size={12} />,
        navLink : '/usuarios/lista',
        rol     : 'Administrador'
      },
      /*
      {
        id      : 'mnuAsesorias',
        title   : 'Asesorias',
        icon    : <Circle size={12} />,
        navLink: '/asesorias/lista'
      },
      */
      {
        id      : 'mnuMaterialApoyo',
        title   : 'Material de apoyo',
        icon    : <Circle size={12} />,
        navLink: '/material-apoyo/lista'
      },
      {
        id      : 'mnuContactos',
        title   : 'Contactos',
        icon    : <Circle size={12} />,
        navLink: '/contactos/lista'
      },
      {
        id      : 'mnuAgentes',
        title   : 'Agentes',
        icon    : <Circle size={12} />,
        navLink: '/agentes/lista'
      }
    ]
  },
  {
    id    : 'mnuResultados',
    title : 'Resultados',
    icon  : <FontAwesomeIcon icon={faTrophy} />,
    children: [
      {
        id    : 'mnuResultados-CaminoProgreso',
        title : 'Camino de trofeos',
        icon  : <Circle size={12} />,
        navLink: '/resultados/camino'
      },
      {
        id    : 'mnuResultados-reporteSise',
        title : 'Concentrado SISE',
        icon  : <Circle size={12} />,
        navLink: '/reportes/SISE'
      },
      {
        id    : 'mnuResultados-PrimaPagada',
        title : 'Prima Pagada',
        icon  : <Circle size={12} />,
        navLink: '/reportes/prima-pagada'
      },
      // {
      //   id    : 'mnuEquivalencias',
      //   title : 'Equivalencias',
      //   icon  : <Circle size={12} />,
      //   navLink: '/resultados/equivalencias'
      // },
      // {
      //   id    : 'mnuProductividad',
      //   title : 'Productividad',
      //   icon  : <Circle size={12} />,
      //   navLink: '/resultados/productividad'
      // },
      {
        id    : 'mnuRetos',
        title : 'Retos',
        icon  : <Circle size={12} />,
        navLink: '/resultados/retos'
      },
      /*
      {
        id    : 'mnuResultados-Eventos',
        title : 'Eventos',
        icon  : <Circle size={12} />,
        navLink: '/resultados/eventos'
      },
      // {
      //   id    : 'mnuResultados-Insignias',
      //   title : 'Insignias',
      //   icon  : <Circle size={12} />,
      //   navLink: '/resultados/insignias'
      // },
      {
        id    : 'mnuResultados-PremiosOtorgados',
        title : 'Premios otorgados',       
        icon  : <Circle size={12} />,
        navLink: '/resultados/premios-otorgados'
      },
      */
      {
        id    : 'mnuResultados-Productos',
        title : 'Tienda',
        icon  : <Circle size={12} />,
        navLink: '/resultados/productos'
      },
      {
        id: 'mnuResultadosCatalogos',
        title: 'Catalogos',                   
        icon: <Circle size={12} />,
        children: [
          {
            id: 'mnuResCat-Ramos',
            title: 'Ramos',
            navLink: '/resultados/catalogos/ramos'
          },
          {
            id: 'mnuResCat-Companias',
            title: 'Compañias',
            navLink: '/resultados/catalogos/companias'
          }
          /*
          {
            id: 'mnuResCat-TiposRetos',
            title: 'Tipos retos',
            navLink: '/resultados/catalogos/tipos-retos'
          }
          */
        ]
      }
    ]
  }
]
